
import MaterialConfigurationApi from './src/MaterialConfigurationResources'
import MaterialManagementApi from './src/MaterialManagementResources'
import MaterialStatApi from './src/MaterialStatResources'
import MaterialUsageApi from './src/MaterialUsageResources'
import FileApi from './src/FileManagementResources'
import ProjectBasicinfoApi from './src/ProjectBasicinfoResources'
import ProjectTaskApi from './src/ProjectTaskResources'

let apis = {
   MaterialConfigurationApi,
   MaterialManagementApi,
   MaterialStatApi,
   MaterialUsageApi,
   FileApi,
   ProjectBasicinfoApi,
   ProjectTaskApi
};

export default apis;
